'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureBreaker = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = require('react-redux');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _featureBreaker = require('../../redux/selectors/featureBreaker');

var selectors = _interopRequireWildcard(_featureBreaker);

var _Button = require('acq-components/lib/base-components/Button/Button');

var _RewardsBanner = require('acq-components/lib/composite-components/Banner/Variations/RewardsBanner');

var _BulletListItem = require('acq-components/lib/base-components/BulletListItem/BulletListItem');

var _componentHelpers = require('../../utils/component-helpers');

var utils = _interopRequireWildcard(_componentHelpers);

var _navigationHelpers = require('../../utils/navigationHelpers.js');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureBreaker = function FeatureBreaker(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      shadeAlternator = _ref.shadeAlternator,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'shadeAlternator']);

  if (!props.featureBreaker) return null;

  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    {
      styles: styles.fullWidthBackground,
      isDarkShade: shadeAlternator.isShaded()
    },
    _react2.default.createElement(
      _RewardsBanner.RewardsBanner,
      {
        title: props.title,
        titleComponent: 'h2',
        secondaryHeadline: props.secondaryHeadline,
        background: {
          img: props.backgroundUrl
        },
        styles: (0, _lodash2.default)(styles, 'rewardsBanner'),
        alignment: 'right',
        namespace: 'feature-breaker',
        button: _react2.default.createElement(
          'div',
          null,
          props.links.map(function (link) {
            return _react2.default.createElement(
              _Button.Button,
              {
                namespace: 'feature-breaker/learn-more',
                onClick: function onClick() {
                  return (0, _navigationHelpers.navigateTo)(link.url);
                },
                dtm: link.dtm,
                title: link.hoverText
              },
              link.title
            );
          })
        ),
        qeId: props.qeId
      },
      props.listItems.map(function (item, index) {
        return _react2.default.createElement(
          _BulletListItem.BulletListItem,
          {
            image: utils.getIconOrImage(item),
            styles: styles.accordionContentItem,
            key: 'feature_breaker_bulletListItem_' + index
          },
          _react2.default.createElement(utils.DescParser, { descArray: item.desc, InnerTag: 'span' })
        );
      })
    )
  );
};

exports.FeatureBreaker = FeatureBreaker;
var mapStateToProps = function mapStateToProps(state) {
  return {
    links: selectors.getLinks(state),
    backgroundUrl: selectors.getBackgroundUrl(state),
    secondaryHeadline: selectors.getSecondaryHeadline(state),
    title: selectors.getTitle(state),
    listItems: selectors.getListItems(state),
    featureBreaker: selectors.getFeatureBreaker(state),
    qeId: selectors.getQeId(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(FeatureBreaker);